import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useOrganization } from "@clerk/clerk-react";
import { useOrgMetadata } from "@/hooks/use-org-metadata";

export function OrganizationInfoCard() {
  const { t } = useTranslation();
  const { organization } = useOrganization();
  const isProfitCenter = organization?.publicMetadata?.type === "profit-center";
  const { metadata } = useOrgMetadata();

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {isProfitCenter ? t("components.organizations.organizationInfoCard.myProfitCenter") : t("components.organizations.organizationInfoCard.myOrganization")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <p className="text-sm font-medium text-muted-foreground">{t("components.organizations.organizationInfoCard.name")}</p>
            <p className="text-lg">{organization?.name || t("components.organizations.organizationInfoCard.nA")}</p>
          </div>
          {metadata?.phone && (
            <div>
              <p className="text-sm font-medium text-muted-foreground">{t("components.organizations.organizationInfoCard.phone")}</p>
              <p className="text-lg">{metadata.phone}</p>
            </div>
          )}
          {metadata?.address && (
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                {t("components.organizations.organizationInfoCard.address")}
              </p>
              <p className="text-lg">
                {metadata.address.street && (
                  <>
                    {metadata.address.street}
                    {metadata.address.street2 &&
                      `, ${metadata.address.street2}`}
                    <br />
                  </>
                )}
                {metadata.address.city && `${metadata.address.city}, `}
                {metadata.address.state} {metadata.address.zipCode}
              </p>
            </div>
          )}
          {metadata?.hajocaCustomerId && (
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                {t("components.organizations.organizationInfoCard.hajocaCustomerId")}
              </p>
              <p className="text-lg">{metadata.hajocaCustomerId}</p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
